import { useBrowseProductEntitlementApi } from '@aibees/shared/api';

export function useRenderValueEntitlement() {
  const { data } = useBrowseProductEntitlementApi();

  const entitlement = data?.features;
  const featuredProduct = data?.products;

  const paidProduct = featuredProduct?.find(
    (p) => p.name?.toLowerCase() === 'standard'
  );

  const freeProduct = featuredProduct?.find(
    (p) => p.name?.toLowerCase() === 'free'
  );

  const renderFreeValue = (name: string) => {
    return entitlement?.find(
      (i) => i.name === name && i.products.some((p) => p === freeProduct?.id)
    )?.metadata.value;
  };

  const renderPaidValue = (name: string) => {
    return entitlement?.find(
      (i) => i.name === name && i.products.some((p) => p === paidProduct?.id)
    )?.metadata.value;
  };

  return { renderFreeValue, renderPaidValue };
}
